import React from "react";

import Modal from "../../pages/CallForTender/components/AddressModal/Modal";
import PdfDocument from "../PdfDocument";

interface PdfModalProps {
    pdfPath: string;
    pdfScale?: number;
    title: string;
    isVisible: boolean;
    onClose: () => void;
}

const PdfModal = ({
    pdfPath,
    pdfScale = 1.0,
    title = "",
    isVisible = false,
    onClose,
}: PdfModalProps) => {
    if (!pdfPath || pdfPath === "") {
        return null;
    }

    return (
        <Modal
            headline={title}
            isActive={isVisible}
            closeButton="Schließen"
            handleClose={() => onClose()}
            actionRow={false}
            disableYOverflow={true}
        >
            <div>
                <PdfDocument pdfPath={pdfPath} scale={pdfScale} />
            </div>
        </Modal>
    );
};

export default PdfModal;
